// class for defining the amzn user-agent
export default UserAgent;
// constructor
function UserAgent() {}
// public
UserAgent.prototype.userAgent = 'aws-amplify/0.1.x js';


//////////////////
// WEBPACK FOOTER
// ../~/amazon-cognito-identity-js/es/UserAgent.js
// module id = 591
// module chunks = 0